module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAABHNCSVQICAgIfAhkiAAAASVJREFUOE9jZKASYCRkzv///88A1fxnZGQ0xacWr0FAQxKAmqeADALiXKBhC3AZhtMgoCECQE1PgZgLqvk7kJYCGvYBm2H4DOoAaigEYjaoxl9Auh9oUAXRBgFdowBUfAOI2dE0/QTyNYCGPUA3DKuLgAatASr0BmIONA0/gPytQINCCBoENMQBqGgLEHPjCNivQHEfoGEHkOUxXAQ06AJQgT6u2IGKXwAaZIjTIGh0TwAq4CdgECjmCpGTA4qLgAa9AioQJWAITPo10CAxGAduENCQBqBgGRBzEmnQN6C6bqBhIH0MYIOgie85llgiZCYoOUiAEinMoGVAgUAyDAIlh/VAg6IYoYnvJlAAloIJuQJdHpTi1WEGXQVyYHmKVINAYaUNAMHNVUuoMh4bAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/jiantou.png
// module id = 9dzv
// module chunks = 1